import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Jobportal.css';
import BackArrow from '../../../BackArrow';

function Jobportal() {
  const navigate = useNavigate();

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };

  const bereich = getCookie('Bereich');

  // Hinweis: Das frühere Cookies.set('selectedJob', '<Seitenname>') ist
  // entfernt — der Cookie gehört Zuteilung_job (speichert dort eine JobID)
  // und wurde durch die Strings nur korrumpiert; gelesen hat sie niemand.
  const handleBewerbungClick = () => {
    navigate('/jobs/bewerbung');
  };

  const handleKinderClick = () => {
    navigate('/jobs/kinderliste');
  };

  const handleAusschreibungenClick = () => {
    navigate('/jobs/stellenausschreibungen');
  };

  const handleZuteilungClick = () => {
    navigate('/jobs/zuteilung_zelt');
  };

  const handleZuteilungJobClick = () => {
    navigate('/jobs/zuteilung_job');
  };

  const handleSelbstständigkeitClick = () => {
    navigate('/parlament/selbstständigkeit');
  };

  return (
    <div>
      <div className="page-header">
        <BackArrow to="/" />
        <h1>JOBPORTAL</h1>
      </div>
      {bereich === 'Zeltbetreuung' && (
        <button className={`jobbutton bereich_button ${bereich.replace(/[^a-zA-Z0-9]/g, '-')}`} onClick={handleBewerbungClick}>Bewerbungen</button>
      )}
      {(bereich === 'Arbeit/Freizeit' || bereich === 'Parlament') && (
        <button className={`jobbutton bereich_button ${bereich.replace(/[^a-zA-Z0-9]/g, '-')}`} onClick={handleZuteilungJobClick}>Kinder im Job</button>
      )}
      {bereich === 'Zeltbetreuung' && (
        <button className={`jobbutton bereich_button ${bereich.replace(/[^a-zA-Z0-9]/g, '-')}`} onClick={handleZuteilungClick}>Zuteilung der Jobs</button>
      )}
      <button className={`jobbutton bereich_button ${bereich.replace(/[^a-zA-Z0-9]/g, '-')}`} onClick={handleAusschreibungenClick}>Stellenausschreibungen</button>
      {bereich === 'Zeltbetreuung' && (
        <button className={`jobbutton bereich_button ${bereich.replace(/[^a-zA-Z0-9]/g, '-')}`} onClick={handleSelbstständigkeitClick}>Selbstständigkeit beantragen</button>
      )}
      {bereich === 'Zeltbetreuung' && (
        <button className={`jobbutton bereich_button ${bereich.replace(/[^a-zA-Z0-9]/g, '-')}`} onClick={handleKinderClick}>Kinderliste</button>
      )}
    </div>
  );
}

export default Jobportal;